<template>
  <div>
    <div class="w-100pct h-60px cl-white f-s-18px f-w-bold pd-18px" :style="`background-color: ${mainColor};`">
      <router-link :to="{ name: 'Home' }">
        <svg-filler class="mg-r-auto f-left cs-pointer" path="/static/svg/back.svg" :fill="'#ffffff'" width="20px" height="20px"/>
      </router-link>
      <span>
        Scan QR code
      </span>
    </div>
    
    <div class="list-item">
      <div class="pst-fixed mg-auto t-0px l-0px r-0px bt-0px w-fit-content h-fit-content t-al-center ">
        <qrcode-reader @decode="onDecode" class="qrcode">
        </qrcode-reader>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'scan-search',
  data () {
    return {
      paused: false
    }
  },
  computed: {
    ...mapGetters({
      mainColor: 'mainColor'
    })
  },
  methods: {
    async onDecode (content) {
      if (content) {
        let contents = content.split('/')
        let idOfProdect = contents[contents.length - 1]
        let hasProduct = await this.setSearchKey(idOfProdect)
        this.playSound()
        this.$router.push({ name: 'Home' })
        if (!hasProduct) {
          this.$dialog.alert({
            title: 'เกิดข้อผิดพลาด',
            confirmText: 'ตกลง',
            message: '<center>ข้อมูลไม่ตรงกับสินค้าในระบบ</center>'
          })
        }
      }
    },
    playSound () {
      let audio = new Audio(require('@/assets/sound/tid.mp3'))
      audio.play()
    },
    ...mapActions([
      'setSearchKey'
    ])
  }
}
</script>

<style scoped>
.list-item {
  overflow: auto;
  height: calc(100vh - 60px);
}
.qrcode{
  width:300px;
  height:300px;
  border: 3px solid black;
}
</style>



// WEBPACK FOOTER //
// src/views/home/ScanToSearch.vue